<script lang="ts">
  import type { UserCheckpointStore } from 'shared/src/user/userLessons/user.checkpoint.store';
  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';

  import type { UserLessonOrCheckpointStore } from 'shared/src/user/userLessons/user.lessonOrCheckpoint.store';
  import { autorun } from 'mobx';
  import LessonInlineStatus from './LessonInlineStatus.svelte';
  import { onDestroy } from 'svelte';
  import CheckpointInlineStatus from './CheckpointInlineStatus.svelte';
  export let lessonOrCheckpointStore: UserLessonOrCheckpointStore;

  let lessonStore: UserLessonStore | null;
  let checkpointStore: UserCheckpointStore | null;
  const destroyer = autorun(() => {
    lessonStore = lessonOrCheckpointStore.type === 'lesson' ? lessonOrCheckpointStore : null;
    checkpointStore =
      lessonOrCheckpointStore.type === 'checkpoint' ? lessonOrCheckpointStore : null;
  });
  onDestroy(destroyer);
</script>

{#if lessonStore}
  <LessonInlineStatus {lessonStore} />
{/if}
{#if checkpointStore}
  <CheckpointInlineStatus {checkpointStore} />
{/if}
